import Box, { BoxProps } from '@mui/material/Box'
import { styles } from './styles'

type Props = BoxProps & {
  children: React.ReactNode
}

export const ContentCenter: React.FC<Props> = ({ children, sx }) => <Box sx={Object.assign(styles, sx)}>{children}</Box>
